import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "../ui/dialog";
import { Button } from "../ui/button";

export const RIDE_CANCEL_REASONS = [
  "Driver too far",
  "Booked by mistake",
  "Waited too long",
  "Changed plans",
];

// Rider picks why they're cancelling so the assigned driver gets context.
export default function CancelReasonDialog({ open, onOpenChange, onConfirm, fee }) {
  const [reason, setReason] = useState(null);
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true);
    try { await onConfirm(reason, note.trim()); setReason(null); setNote(""); }
    finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!busy) onOpenChange(v); }}>
      <DialogContent data-testid="cancel-reason-dialog">
        <DialogHeader>
          <DialogTitle>Cancel this ride?</DialogTitle>
          <DialogDescription>
            {fee ? "A ₹20 cancellation fee will be kept and the rest refunded." : "Tell your driver why — it helps them plan."}
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-wrap gap-2 py-1">
          {RIDE_CANCEL_REASONS.map((r) => (
            <button
              key={r}
              type="button"
              onClick={() => setReason(r === reason ? null : r)}
              data-testid={`cancel-reason-${r.replace(/\s+/g, "-").toLowerCase()}`}
              className={`rounded-full border px-3 py-1.5 text-sm font-medium transition-colors ${reason === r ? "border-brand bg-brand text-white" : "border-surface-300 text-ink-soft hover:bg-surface-100"}`}
            >
              {r}
            </button>
          ))}
        </div>
        <textarea
          value={note}
          onChange={(e) => setNote(e.target.value)}
          maxLength={280}
          rows={2}
          placeholder="Add a note (optional)"
          data-testid="cancel-reason-note"
          className="w-full resize-none rounded-xl border border-surface-300 bg-white px-3 py-2 text-sm text-ink outline-none focus:border-brand"
        />
        <DialogFooter className="gap-2 sm:gap-2">
          <Button type="button" variant="ghost" onClick={() => onOpenChange(false)} disabled={busy} data-testid="cancel-reason-keep">Keep ride</Button>
          <Button type="button" onClick={submit} disabled={busy} className="rounded-full bg-red-600 text-white hover:bg-red-700" data-testid="cancel-reason-confirm">
            {busy ? "Cancelling…" : "Cancel ride"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
